import ModalDeleteFilled from '../../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteBuyOrderDraftProps extends ModalEditComponentProps { }

const ModalDeleteBuyOrderDraft: React.FC<ModalDeleteBuyOrderDraftProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/order/buy/buyOrder/deleteBuyOrderDraft',
        data: {
            id: allRowData?.header?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteDraftBuyOrder', '¿Seguro que quieres eliminar este borrador de compra?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteBuyOrderDraft